import React from "react";
import _ from "lodash";
import { useSelector } from "react-redux";

import { useVolatileSettings } from "../../hooks";
import { selectUserRole } from "../../userContext/redux/userContext.selectors";
import { UserRoleName } from "../../userContext/userContext.constants";

import { Tag } from "./tagList.styled";

export const TagList = ({ tags }) => {
  const userRole = useSelector(selectUserRole);
  const { handleSearchPopupOpen } = useVolatileSettings();

  if (userRole?.name === UserRoleName.Onboarding || !tags) {
    return null;
  }

  const renderCompetences = () =>
    tags.map((tag) => {
      const name = _.upperFirst(_.camelCase(tag.name));
      return (
        <React.Fragment key={tag.id}>
          <Tag onClick={() => handleSearchPopupOpen(`#${name}`)}>
            #{name}
          </Tag>
          {!!tag.skills && renderCompetenceSkills(tag)}
        </React.Fragment>
      );
    });

  const renderCompetenceSkills = (competence) =>
    competence.skills.map((skill) => {
      const name = _.upperFirst(_.camelCase(skill.name));
      return (
        <Tag key={skill.id} onClick={() => handleSearchPopupOpen(`#${name}`)}>
          #{name}
        </Tag>
      );
    });

  return renderCompetences();
};
